import { connect } from "react-redux";
import BillingHistory from "./BillingHistory";
import { getRequestStatistics } from "../redux/selectors";
import { addIdToArrayElements, dateTimeFormatted } from "Utils";
const mapStateToProps = state => ({
    history: addIdToArrayElements(getRequestStatistics(state), "Id").map(item => ({
        ...item,
        pointsLeftAfterRequest: item.points_left_before_request - item.points_written_off,
        createdDate: dateTimeFormatted(item.created, "dd.MM.yyyy"),
        createdTime: dateTimeFormatted(item.created, "hh:mm")
    }))
});
export default connect(mapStateToProps)(BillingHistory);
